import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError } from '@/views/skud/shared/modules/skud-http'

export class SkudCommandEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // body: {type (int 0..8), point_id?, payload?} — point_id null = всем точкам места.
  // -> {ok:true, data:{command_id}} | {ok:false, error}
  async issueCommand (placeId, body) {
    const res = await this.webApi.post(this.url + 'places/' + placeId + '/commands', body)
    const data = unwrapEnvelope(res)
    return data ? { ok: true, data: data } : { ok: false, error: envelopeError(res) || 'Ошибка запроса' }
  }
}
